import { useState } from "react";
import { ArtifactType, GetProfileQueryQuery } from "types/graphql-schema";

import ArtifactCreationDialog from "@apps/artifact-creation-dialog/artifact-creation-dialog";
import useLabel from "@apps/use-label/use-label";
import Button from "@components/button/button";
import { ButtonSize, buttonTheme } from "@components/button/button-constants";

import getProfileArtifactsQuery from "../graphql/get-profile-artifacts-query";
import { ProfileGoals } from "./profile-artifacts";

type ProfileForGoals = NonNullable<GetProfileQueryQuery["user"]>;

// The standalone "Goals" profile tab. Goals used to live as a sub-tab inside the
// combined "Items" tab; they now get their own top-level tab. This mirrors the
// Items tab's outer layout (one header + a "Create" button) so the two tabs read
// as siblings, then reuses the shared ProfileGoals list with its own header
// suppressed (hideHeader) since this component owns the header + create action.
const ProfileGoalsTab = ({ profile }: { profile: ProfileForGoals }) => {
  const label = useLabel();
  const [showCreateDialog, setShowCreateDialog] = useState(false);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between pt-2">
        <div className="text-lg font-semibold text-gray-900">
          {label("goal", { titleCase: true, pluralize: true })}
        </div>
        <Button
          theme={buttonTheme.primary}
          size={ButtonSize.medium}
          text={`Create ${label("goal", { titleCase: true })}`}
          onClick={() => setShowCreateDialog(true)}
        />
      </div>
      <ProfileGoals profile={profile} bare hideHeader />
      {showCreateDialog && (
        <ArtifactCreationDialog
          hideTypeSelector
          formOptions={{ artifactType: ArtifactType.Goal, owners: [profile] }}
          onClose={() => setShowCreateDialog(false)}
          refetchQueries={[getProfileArtifactsQuery]}
        />
      )}
    </div>
  );
};

export default ProfileGoalsTab;
